import Rails from "@rails/ujs"
import Sortable from 'sortablejs'
export const taskSorter = function() {

  let tasks = document.querySelector(".tasks.sortable")
  if (tasks) {
    let sortable = new Sortable(tasks,{
      handle: ".sort-handle",
      onEnd: function(e) {
        let source = document.querySelector(".tasks.sortable")
        let url = source.dataset["url"]
        let ids = Array.from( source.querySelectorAll(".task")).map(x => x.id.substr(5)) 

        fetch( url, {
          method: "put",
          body: JSON.stringify({order: ids}),
          headers: {
            'X-CSRF-Token':  document.getElementsByName('csrf-token')[0].getAttribute('content'),
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type':     'application/json',
            'Accept':           'application/html'
          },
          credentials: 'same-origin'
        })
      }
    });
  }

}
